export const Menus = {
    CAMP: "CAMP",
};
